import { Link } from 'react-router-dom';
import { useState, MouseEvent } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store';
import { logout } from 'store/slices/auth';

import { Icon } from '../icons';
import { Button } from '../button';

import { UserDropdownProps } from './types';

export const UserDropdown = ({
  links,
  showLogoutButton,
}: UserDropdownProps) => {
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { t } = useTranslation(['header']);

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        color="secondary"
        variant="contained"
        onClick={handleOpen}
        className="ml-4 hidden xl:flex"
        buttonClassName="flex h-8 w-8 min-w-0 items-center justify-center rounded-full sm:h-10 sm:w-10"
      >
        <Icon.User />
      </Button>
      <Menu
        anchorEl={anchorEl}
        onClose={handleClose}
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            className: 'p-0 border border-gray-primary mt-1',
          },
        }}
      >
        {links.map((link) => (
          <MenuItem
            key={link.href}
            to={link.href!}
            component={Link}
            onClick={handleClose}
            className="font-bold"
          >
            {t(link.i18nKey)}
          </MenuItem>
        ))}

        {showLogoutButton && (
          <MenuItem
            className="flex gap-2 font-bold"
            onClick={() => {
              dispatch(logout({ byUser: true }));
              handleClose();
            }}
          >
            <Icon.LogOut className="[&_path]:fill-current" />
            {t('logOut')}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};
